import { render, staticRenderFns } from "./SahabatZX.vue?vue&type=template&id=7e86a834"
import script from "./SahabatZX.vue?vue&type=script&lang=js"
export * from "./SahabatZX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports